import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom'

//<script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDVP24GCb-GxfzqeY6v6WJv11kCLdGKa7M&libraries=places"></script>

ReactDOM.render((
    <BrowserRouter>
        <App />
    </BrowserRouter>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js